import { Api } from '../api';
import { messages } from '../endpoints';
import type { GetMessagesThreadResponse, GetMessagesThreadsResponse, PostMessageRequest } from './models';

export class MessagesApi extends Api {
  static getMessagesCount = (refreshToken: string) =>
    this.get<number>({ url: messages.getMessagesCount(), headers: { Authorization: 'Bearer ' + refreshToken } });

  static getMessagesThread = (threadId: string) => this.get<GetMessagesThreadResponse>({ url: messages.getMessagesThread(threadId) });

  static getMessagesThreads = () => this.get<GetMessagesThreadsResponse[]>({ url: messages.getMessagesThreads() });

  static getMessageFile = (messageId: string, filename: string) => this.get<Blob>({ url: messages.getMessageFile(messageId, filename) });

  static postMessage = (request: PostMessageRequest) =>
    this.post<PostMessageRequest, GetMessagesThreadsResponse>({ url: messages.postMessage(), data: request });

  static deleteMessagesThread = (threadId: string) => this.delete<undefined>({ url: messages.deleteMessagesThread(threadId) });
}
